module.exports = __webpack_public_path__ + "static/apple-icon-144x144-962e0de17a9a1f6aa5d117e84d2903e0.png";